import { QueryClientProvider } from '@tanstack/react-query';
import type { FC, ReactNode } from 'react';
import { ApiContext } from './ApiContext';
import { DefaultApi } from './DefaultApi';

interface Props {
  readonly children: ReactNode;
}

export const ApiProvider: FC<Props> = ({ children }) => {
  const api = new DefaultApi();
  return (
    <QueryClientProvider client={api.queryClient}>
      <ApiContext.Provider value={api}>{children}</ApiContext.Provider>
    </QueryClientProvider>
  );
};
